interface ProgramSkeletonProps {
    showBadge?: boolean;
}

export default function ProgramSkeleton({ showBadge = true }: ProgramSkeletonProps) {
    return (
        <div className="pb-16 animate-pulse">
            {/* Program badge */}
            {showBadge && (
                <div className="flex items-center gap-2 mb-1">
                    <div className="w-6 h-6 rounded-full bg-gray-200 flex-shrink-0" />
                    <div className="h-3.5 w-32 bg-gray-200 rounded" />
                </div>
            )}
            {/* Requirement header */}
            <div className="flex items-center justify-between">
                <div className="h-5 w-24 bg-gray-200 rounded" />
                <div className="h-4 w-28 bg-gray-100 rounded" />
            </div>
            {/* Course rows */}
            <table className="w-full border-collapse">
                <tbody>
                    {[0, 1, 2].map(i => (
                        <tr key={i}>
                            <td className="w-10 pl-4 pr-2 py-4">
                                <div className="w-5 h-5 bg-gray-100 rounded mx-auto" />
                            </td>
                            <td className="w-32 pl-2 pr-2 py-4">
                                <div className="h-4 bg-gray-100 rounded w-20" />
                            </td>
                            <td className="pl-2 pr-4 py-4">
                                <div className="h-4 bg-gray-100 rounded w-3/4" />
                            </td>
                            <td className="px-2 py-4 w-16">
                                <div className="h-4 bg-gray-100 rounded w-4 ml-auto" />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
